module.exports = __webpack_public_path__ + "img/1571540733.a0c71847.jpg";